/**
 * Legacy route - redirects to Add Production (crew CSV import).
 */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import './Signup.css';
import './OrgSignup.css';

export default function OrgCreateProject() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/org/productions/new', { replace: true });
  }, [navigate]);

  return (
    <div className="signup-page" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div className="org-signup-spinner" aria-label="Loading" />
    </div>
  );
}
